import React from 'react';
import image_1 from '../../CustomAssets/Images/AbouUsPage/image_1.svg';  
import image_2 from '../../CustomAssets/Images/AbouUsPage/image_2.svg';  
import image_3 from '../../CustomAssets/Images/AbouUsPage/image_3.svg';  

const Image = ({ src, alt }) => (
  <img decoding="async" className="unset" src={src} alt={alt} />
);

export const Img1 = () => <Image src={image_1} alt="Image 1" />;
export const Img2 = () => <Image src={image_2} alt="Image 2" />;
export const Img3 = () => <Image src={image_3} alt="Image 3" />;
